<template>
  <v-row justify="space-between" align="center">
    <v-col cols="12" sm="12" md="4" lg="4" class="d-flex align-center">
      <h1 class="titulo-2 color-purpura-base">
        ¿Qué estudio hoy?
      </h1>
    </v-col>

  

    <!-- filter -->
    <v-col cols="12">
        <RomaFilter :options="filterLesson()" />
    </v-col>
  </v-row>
</template>

<script>
import "@/assets/styles/colors.scss";
import RomaFilter from "@/components/commons/RomaFilter.vue";
import { mapActions, mapGetters } from "vuex";
import RomaFormNewLesson from "./RomaFormNewLesson";

export default {
  name: "RomaFilterLesson",
  data() {
    return {
      buttonOptions: {
        title: "Nueva Clase",
        icon: "mdi-plus",
        color: "accent",
      },
      items: [],
      component: RomaFormNewLesson,
      subjectModel: "",
    };
  },
  mounted() {
    this.getLessonInfo({ institutionId: this.user.institutionContext.institutionId });
  },
  computed: {
    ...mapGetters({
      filter: "getLessonFilterInformation",
      getGridColumnLesson: "getGridColumnLesson",
      user: "getUserData"
    }),
  },
  components: {
    // Modal,
    RomaFilter,
  },
  methods: {
    ...mapActions({
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      getLessonInfo: "actionGetFilterInformationLesson",
    }),
    filterLesson() {
      const subjectList = this.filter.subjectList;
      const levelList = this.filter.educationList;
      const sectionList = this.filter.sectionList;
      const unitList = this.filter.unitList;

      const subject = [];
      for (const item of subjectList) {
        subject.push({
          id: item.subjectId,
          text: item.name,
          subjectId: item.subjectId,
        });
      }

      const level = [];
      for (const item of levelList) {
        level.push({
          id: item.educationId,
          text: item.name,
          educationId: item.educationId,
        });
      }

      // const course = [];
      // for (const item of sectionList) {
      //   course.push({
      //     id: item.sectionId,
      //     text: item.nameAndCategoryName,
      //     sectionId: item.sectionId,
      //   });
      // }

      // const unit = [];
      // for (const item of unitList) {
      //   unit.push({ id: item.unitId, text: item.name, unitId: item.unitId });
      // }

      return [
        {
          label: this.$vuetify.lang.t("Asignatura"),
          type: "select",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("Asignatura") },
          query: `subjectId=`,
          options: subject,
          offset: "0",
        },
        {
          label: this.$vuetify.lang.t("Nivel"),
          type: "select",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("Nivel") },
          query: `educationId=`,
          options: level,
          offset: "0",
        },
        { type: "spacer", cols: 6 },
        {
          label: this.$vuetify.lang.t("Título"),
          type: "text",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("") },
          query: `title=`,
          options: [],
          offset: "6",
        },
        {
          label: this.$vuetify.lang.t("Estado"),
          type: "select",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("Estado") },
          query: `stateId=`,
          options: [
            {
              id: 2,
              text: "Opción 1",
              uid: 0,
            },
            {
              id: 1,
              text: "Opción 2",
              uid: 0,
            },
          ],
          offset: "0",
        },
        {
          label: this.$vuetify.lang.t("Fecha Entrega Inicio"),
          type: "select",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("Fecha Entrega Inicio") },
          query: `dateInit=`,
          options: [
            {
              id: 2,
              text: "Opción 1",
              uid: 0,
            },
            {
              id: 1,
              text: "Opción 2",
              uid: 0,
            },
          ],
          offset: "0",
        },
        {
          label: this.$vuetify.lang.t("Fecha Entrega Fin"),
          type: "select",
          cols: 3,
          model: { id: 0, text: this.$vuetify.lang.t("Fecha Entrega Fin") },
          query: `dateEnd=`,
          options: [
            {
              id: 2,
              text: "Opción 1",
              uid: 0,
            },
            {
              id: 1,
              text: "Opción 2",
              uid: 0,
            },
          ],
          offset: "0",
        },
      ];
    },
    showFilterModal() {
      this.showFilter = !this.showFilter;
    },
    changeGrid() {
      this.$store.commit("SET_COLUMN_GRID_LESSON");
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/generals.scss';
.filter-lesson-content {
  &__title {
    font-size: 36px !important;
  }
  &__dialog {
    .v-btn__content {
      display: grid;
      font-size: 16px;
      grid-template-columns: 32px max-content 32px;
      span {
        grid-column: 2 / 3;
      }
      i {
        grid: 3 / 4;
      }
    }
  }
  .mode-new-lesson {
    &__img {
      width: 300px;
      height: auto;
      margin: 0 auto;
    }
    &__description {
      text-align: center;
      max-width: 320px;
      margin: 0 auto;
    }
  }
  .icon-class {
    height: 35px;
  }
  .header-filter {
    h1 {
      color: $morado;
    }
  }

  h1,
  .icon-class {
    color: $morado;
    font-weight: normal;
    font-size: 26px;
  }

  .container-search {
    margin-top: 0 !important;
  }

  .icon-class {
    color: $morado !important;
    margin: 0 20px 0 5px;
  }

  .theme--light.v-icon {
    color: $morado;
  }

  .input-search {
    min-height: 60px !important;
  }

  .reorder-icon:before {
    content: url("../../assets/icons/list-mode.svg");
  }

  .btn-view-list {
    padding: 5px !important;
    width: 50px !important;
    height: 50px !important;
    box-shadow: none;
    background: #e9e9e9 !important;
    i {
      color: map-get($colors, "gray-dart") !important;
    }
  }
}
</style>
